import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterList',
  standalone: false
})
export class FilterListPipe implements PipeTransform {
  transform<T>(list: T[], filterBy: (T) => boolean): T[] {
    return list?.filter(filterBy);
  }
}
